export function Ped() {
  return (
    <h1>Ped</h1>
  )
}